import './rules.css'

function RuleItem({rule, url, categoryIndex, index}:any) {
    return (
        <div className={!url ? "rules__block_item": "rules__block_item unban"}>
            {index && categoryIndex && <span className="rules-index"><strong>{categoryIndex}.{index}</strong></span>} {rule} {url && <a className="rules__block_url" href={url} target="_blank">{'vk.com/rusty_life_moder'}</a>}
        </div>
    )
}

export default function RulesBlock({t,title,items, url, categoryIndex}:any) {
    return(
        <div className={!url ? "rules__block": "rules__block unban"}>
            <div className="rules__block_title">{title}</div>
            <div className="rules__block_items">
                {items.map((item:any,index:number) => (
                    <RuleItem
                    key = {item}
                    rule = {item}
                    url = {url}
                    index = {index+1}
                    categoryIndex = {categoryIndex}
                    />
                ))}
            </div>
        </div>
    )
}